import React, { useEffect, useRef } from 'react'
import { i18n } from '@fs/zion-locale'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

window.HELP_IMPROVE_VIDEOJS = false

export default function VideoJs({ children, classes, cursor, options, onReady }) {
  const videoRef = useRef(null)
  const playerRef = useRef(null)

  useEffect(() => {
    // Dispose the Video.js player when the functional component unmounts
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose()
        playerRef.current = null
      }
    }
  }, [])

  useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current && videoRef.current) {
      const currentLanguage = i18n.language === 'zh' ? 'zh-hant' : i18n.language
      playerRef.current = videojs(
        videoRef.current,
        { ...(options || {}), language: options?.language || currentLanguage },
        () => {
          onReady?.(playerRef.current)
        }
      )
    }
  }, [onReady, options, videoRef])

  return (
    <div data-vjs-player>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video ref={videoRef} className={`video-js ${(classes ?? []).join(' ')}`} style={{ cursor: cursor ?? 'default' }}>
        {children}
        <p className="vjs-no-js">{i18n.t('Video.text.videoNotSupported', 'Video is not supported on your device.')}</p>
      </video>
    </div>
  )
}
